<template>
  <div class="container mt-2">
    <div class="d-flex flex-row gap-2 mb-2">
      <div class="d-flex align-items-center position-relative w-100">
        <input type="text" class="form-control m-0 sombra-sm" style="height: 40px;" :placeholder="$t('buscarPorNombre') + '...'" v-model="searchTerm" @keyup.enter="fetchUsers(1)" @input="filterUsers"/>
        <button v-if="searchTerm" type="button" class="position-absolute top-50 end-0 translate-middle-y border-0 bg-transparent" @click="searchTerm = ''; fetchUsers(1)">
          <i class="bi bi-x text-secondary" style="font-size: 30px;"></i> <!-- Icono de "x" -->
        </button>
      </div>
      <div class="select-wrapper w-100" style="max-width: 100px;">
        <select v-model="año" class="form-select w-100 fs-8 borde-terciario sombra-sm texto-principal" style="max-width: 100px; height: 40px;" @change="expandedUserId = ''">
          <option v-for="añoDisponible in Array.from({ length: new Date().getFullYear() - 2024 + 1 }, (_, i) => 2024 + i)" 
                  :key="añoDisponible" 
                  :value="añoDisponible">
            {{ añoDisponible }}
          </option>
        </select>
        <svg class="select-icon" viewBox="0 0 20 20" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
          <path d="M5.23 7.21a.75.75 0 0 1 1.06.02L10 11.06l3.71-3.83a.75.75 0 1 1 1.08 1.04l-4.25 4.4a.75.75 0 0 1-1.08 0l-4.25-4.4a.75.75 0 0 1 .02-1.06z"/>
        </svg>
      </div>
    </div>


    <table class="table-striped w-100 mb-2 sombra-sm">
      <thead>
        <tr>
          <th class="user-select-none">
            {{$t('apellido')}}
          </th>
          <th class="user-select-none">
            {{$t('nombre')}}
          </th>
          <!-- <th class="user-select-none">
            {{$t('dniPasaporte')}}
          </th> -->
          <th class="user-select-none d-none d-lg-table-cell">
            {{$t('nivel')}}
          </th>
          <th class="user-select-none d-none d-md-table-cell">
            {{$t('cursoGrupo')}}
          </th>
          <th class="user-select-none d-none d-md-table-cell">
            {{$t('rol')}}
          </th>
          <th style="width: 5px;"></th>
        </tr>
      </thead>
      <tbody>
        <template v-for="user in users" :key="user.IdPersona">
          <!-- Fila de información del usuario -->
          <tr @click="toggleDetalle(user)" style="cursor: pointer;">
            <td class="fs-7 align-middle p-1 px-2">{{ user.last_name }}</td>
            <td class="fs-7 align-middle p-1 px-2">{{ user.name }}</td>
            <!-- <td class="fs-7 align-middle p-1 px-2">{{ user.document_number }}</td> -->
            <td class="fs-7 align-middle p-1 px-2 d-none d-lg-table-cell">{{ user.nivel }}</td>
            <td class="fs-7 align-middle p-1 px-2 d-none d-md-table-cell">{{ user.curso }}</td>
            <td class="fs-7 align-middle p-1 px-2 d-none d-md-table-cell">{{ $t(user.rolesText ?? '') }}</td>
            <td class="fs-7 align-middle p-1 px-2">
              <svg width="20px" height="20px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" :style="{ transform: expandedUserId === user.id ? 'scaleY(1)' : 'scaleY(-1)' }">
                <path d="M5.70711 9.71069C5.31658 10.1012 5.31658 10.7344 5.70711 11.1249L10.5993 16.0123C11.3805 16.7927 12.6463 16.7924 13.4271 16.0117L18.3174 11.1213C18.708 10.7308 18.708 10.0976 18.3174 9.70708C17.9269 9.31655 17.2937 9.31655 16.9032 9.70708L12.7176 13.8927C12.3271 14.2833 11.6939 14.2832 11.3034 13.8927L7.12132 9.71069C6.7308 9.32016 6.09763 9.32016 5.70711 9.71069Z" class="fill-principal"/>
              </svg>
            </td>
          </tr>

          <!-- Fila de documentos asociados al usuario (se muestra si está expandido) -->
          <tr v-if="expandedUserId === user.id" :key="'permissions-' + user.id">
            <td colspan="6">
              <div class="permissions-list d-flex flex-column justify-content-center gap-1 m-0">
                <div v-if="loadingDocuments" class="loading-spinner d-flex flex-row align-items-center justify-content-center">
                  <img src="../../assets/LOADING.gif" style="width: 50px;" alt="Cargando..." />
                </div>
                <div v-if="loadingDocuments" class="text-center fs-7">{{$t('cargandoDocs')}}...</div>
                <div v-else>
                  <div v-if="documents.length > 0">
                    <!-- Encabezados de las columnas -->
                    <div class="d-flex flex-row justify-content-between align-items-center py-2 fondo-terciario borde-secundario fw-bold border-bottom">
                      <div class="col-6 ps-2">{{$t('titulo')}}</div>
                      <div class="col">{{$t('documento')}}</div>
                      <div class="col d-none d-sm-block">{{$t('leido')}}</div>
                      <div class="col d-none d-md-block">{{$t('fecha')}}</div>
                      <div v-if="hasEliminarDocFidu" class="col narrow-column"></div>
                    </div>

                    <!-- Lista de documentos -->
                    <ul class="p-0">
                      <li v-for="document in sortedDocuments" :key="document.id" class="d-flex flex-row justify-content-between align-items-center py-2 border-bottom borde-secundario">
                        <div class="col-6 ps-2">
                          <p class="m-0 text-wrap fs-7">{{ document.title }}</p>
                        </div>
                        <div class="col">
                          <a :href="document.file" target="_blank" rel="noopener noreferrer" class="fs-7">
                            {{$t('verDocumento')}}
                          </a>
                        </div>
                        <div class="col d-none d-sm-block">
                          <p class="m-0 fs-7 ms-1">{{ document.viewed ? 'Sí' : 'No' }}</p>
                        </div>
                        <div class="col d-none d-md-block">
                          <p class="m-0 fs-7">{{ new Date(new Date(document.date)).toLocaleDateString('es-ES', {
                              year: 'numeric',
                              month: '2-digit',
                              day: '2-digit',
                              hour: '2-digit',
                              minute: '2-digit',
                              hour12: false, // Para usar el formato de 24 horas
                            }).slice(0, 10) }}</p>
                        </div>
                        <div v-if="hasEliminarDocFidu" class="col narrow-column">
                          <button class="btn p-0 d-flex flex-row align-items-center justify-content-center tooltip-container border-0" @click="isDeleteConfirmVisible = true; documentIdToDelete = document.id; documentNameToDelete = document.title; documentUserNameToDelete = user.last_name + ' ' + user.name">
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="stroke-principal">
                              <path d="M10 11V17" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                              <path d="M14 11V17" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                              <path d="M4 7H20" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                              <path d="M6 7H12H18V18C18 19.6569 16.6569 21 15 21H9C7.34315 21 6 19.6569 6 18V7Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                              <path d="M9 5C9 3.89543 9.89543 3 11 3H13C14.1046 3 15 3.89543 15 5V7H9V5Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                            <span class="tooltip-text">{{ $t('eliminar') }}</span>
                          </button>
                        </div>
                      </li>
                    </ul>
                  </div>
                  <div class="p-2 px-3" v-else>
                    {{$t('noDocsDisponibles')}}.
                  </div>
                </div>
              </div>
            </td>
          </tr>
        </template>
      </tbody>
    </table>
    <div v-if="loading" class="loading-spinner d-flex flex-row align-items-center justify-content-center">
      <img src="../../assets/LOADING.gif" style="width: 80px;" alt="Cargando..." />
    </div>


    <!-- Controles de Paginación Alumnos --> 
    <nav aria-label="Page navigation" class="d-flex flex-row mb-2">
      <ul class="pagination m-0 sombra">
        <li class="p-2 rounded-start bg-goethe-accent-claro-3 borde-secundario border-1 border-end" :class="{ disabled: currentPage === 1 }">
          <a class="p-2 text-dark text-decoration-none" href="#" @click.prevent="fetchUsers(currentPage - 1)">{{ $t('anterior') }}</a>
        </li>
        <li class="p-2 bg-goethe-accent-claro-3 borde-secundario">
          <a class="p-2 text-dark text-decoration-none" href="#" @click.prevent="">{{ currentPage }} {{$t('de')}} {{ totalPages }}</a>
        </li>
        <li class="p-2 rounded-end bg-goethe-accent-claro-3 borde-secundario border-1 border-start" :class="{ disabled: currentPage === totalPages }">
          <a class="p-2 text-dark text-decoration-none" href="#" @click.prevent="fetchUsers(currentPage + 1)">{{ $t('siguiente') }}</a>
        </li>
      </ul>
    </nav>

    <!-- Modal de confirmación -->
    <template v-if="isDeleteConfirmVisible">
      <div class="modal-overlay" @click="isDeleteConfirmVisible = false">
        <div class="modal-content" @click.stop>
          <p>{{$t('seguroEliminarDoc')}}</p>
          <p>"{{ documentNameToDelete }}" {{ $t('delAlumno') }}: {{ documentUserNameToDelete }}</p>
          <div class="d-flex flex-row gap-2 w-100">
            <button class="btn btn-danger w-100" @click="deleteDoc">{{ $t('Si') }}</button>
            <div v-if="loadingDeleteDocuments" class="loading-spinner d-flex flex-row align-items-center justify-content-center">
              <img src="../../assets/LOADING.gif" style="width: 40px;" alt="Cargando..." />
            </div>
            <button class="btn btn-secondary w-100" @click="isDeleteConfirmVisible = false">{{ $t('No') }}</button>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { ref, onMounted, onBeforeUnmount, computed, reactive } from 'vue';
import {useStore} from "vuex";
import {useRouter} from "vue-router";
import { useI18n } from 'vue-i18n';
  import api from '@/services/api';

export default {
  name: 'UsuariosFidu',
  setup() {
    const { t } = useI18n();
    const users = ref([]);
    const documents = ref([]);
    const sortedDocuments = ref([]);
    const año = ref(new Date().getFullYear());
    const searchTerm = ref('');
    let currentPage = ref(1);
    let itemsPerPage = ref(20); // Número de usuarios por página
    let totalPages = ref(1);
    const expandedUserId = ref(''); // ID del usuario expandido
    var loading = ref(false);
    var loadingDocuments = ref(false);
    var loadingDeleteDocuments = ref(false);
    var isDeleteConfirmVisible = ref(false);
    var documentIdToDelete = ref('');
    var documentNameToDelete = ref('');
    var documentUserNameToDelete = ref('');
    const router = useRouter();
    const store = useStore();
    const user = computed(() => store.state.user);
    const errors = reactive({
      Roles: '',
      Permisos: '',
    });
    const hasEliminarDocFidu = ref(false);
    const permisosNiveles = ref([]);
    const showModal = ref(false);
    let connection;
    let timeoutId = null;
    const tipoDocsFromPermissions = ref([])

    const checkAuth = async  () => {
      if (user.value && user.value.personasPermisos) {
        var categoriaAComprobar = 'VerAlumnosFidu'
        if (user.value.personasPermisos.some(persPermiso => persPermiso.idPermisoNavigation?.subCategoria === categoriaAComprobar) || 
          user.value.personasRoles.some(persRoles => persRoles.idRolNavigation?.permisos?.some(p => p.subCategoria === categoriaAComprobar))){
          console.log("Tiene Permiso")
        }
        else{
          console.log('Usuario no tiene permiso a acceder.');
          await router.push('/');
        }
        
        var permisoAComprobar = 'EliminarDocFidu'
        if (user.value.personasPermisos.some(persPermiso => persPermiso.idPermisoNavigation?.permiso === permisoAComprobar) || 
          user.value.personasRoles.some(persRoles => persRoles.idRolNavigation?.permisos?.some(p => p.permiso === permisoAComprobar))){
          hasEliminarDocFidu.value = true;
        }
        permisoAComprobar = 'VerAlumnosKGFidu'
        if (user.value.personasPermisos.some(persPermiso => persPermiso.idPermisoNavigation?.permiso === permisoAComprobar) || 
          user.value.personasRoles.some(persRoles => persRoles.idRolNavigation?.permisos?.some(p => p.permiso === permisoAComprobar))){
          permisosNiveles.value.push("Kindergarten")
        }
        
        permisoAComprobar = 'VerAlumnosEPFidu'
        if (user.value.personasPermisos.some(persPermiso => persPermiso.idPermisoNavigation?.permiso === permisoAComprobar) || 
          user.value.personasRoles.some(persRoles => persRoles.idRolNavigation?.permisos?.some(p => p.permiso === permisoAComprobar))){
          permisosNiveles.value.push("Primaria")
        }
        
        permisoAComprobar = 'VerAlumnosESFidu'
        if (user.value.personasPermisos.some(persPermiso => persPermiso.idPermisoNavigation?.permiso === permisoAComprobar) || 
          user.value.personasRoles.some(persRoles => persRoles.idRolNavigation?.permisos?.some(p => p.permiso === permisoAComprobar))){
          permisosNiveles.value.push("Secundaria")
        }
      }
    };

    // Fetch roles de la BD
    const fetchDocuments = async (persona) => {
      try {
        loadingDocuments.value = true

        let fiduUserId = persona.id == null ? "0" : persona.id
        
        const tipoDocParams = (tipoDocsFromPermissions.value || [])
          .map(docType => `tipoDoc=${encodeURIComponent(docType)}`)
          .join('&');

        const url = `api/FiduDocumentos/ByIdAlumno?apellidoNombre=${encodeURIComponent(persona.last_name + ' ' + persona.name)}&dniPass=123&FiduUserId=${fiduUserId}&año=${año.value}&${tipoDocParams}`;

        const response = await api.get(url);
        documents.value = response.data;
        console.log('documents.value')
        console.log(documents.value)
        
        sortedDocuments.value = documents.value.slice().sort((a, b) => {
          // Convertimos las fechas a objetos Date para compararlas
          const dateA = new Date(a.creation_date);
          const dateB = new Date(b.creation_date);
          return dateB - dateA; // Orden descendente (más reciente primero)
        });
        loadingDocuments.value = false
      } catch (error) {
        console.error('Error al obtener documentos:', error);
      }
    };

    const getDocumentTypesFromPermissions = () => {
      const allowedDocTypes = [];

      const checkAndExtract = (permissionName) => {
        // Regular expression to extract the text between "Ver" and "Fidu"
        const match = permissionName.match(/Ver(.*)Fidu/);
        if (match && match[1]) {
          return match[1]; // The captured group is the part we need
        }
        return null;
      };

      const possiblePermissions = [
        'VerBoletinesFidu',
        'VerInformesFidu',
        'VerFacturasFidu'
      ];

      possiblePermissions.forEach(permisoAComprobar => {
        const hasPermission = user.value.personasPermisos.some(persPermiso =>
          persPermiso.idPermisoNavigation?.permiso === permisoAComprobar
        ) || user.value.personasRoles.some(persRoles =>
          persRoles.idRolNavigation?.permisos?.some(p => p.permiso === permisoAComprobar)
        );

        if (hasPermission) {
          const extractedType = checkAndExtract(permisoAComprobar);
          if (extractedType) {
            allowedDocTypes.push(extractedType);
          }
        }
      });

      return allowedDocTypes;
    };

    const filterUsers = () => {
      // Limpia el temporizador anterior si existe
      if (timeoutId) {
        clearTimeout(timeoutId);
      }

      // Establece un nuevo temporizador
      timeoutId = setTimeout(() => {
        // Llama a fetchUsers después de 500ms (0.5 segundos) de inactividad
        fetchUsers(1);
      }, 1000); // Puedes ajustar este valor a tu gusto (en milisegundos)
    };

    const fetchUsers = async (page) => {
      try {
        loading.value = true
        console.log('prueba')
        if(page <= totalPages.value && page >= 1){
          if (timeoutId) {
            clearTimeout(timeoutId);
          }
          users.value = []

        console.log('prueba2')
          const response = await api.get(`api/FiduAlumnos`, {
            params: {
              año: año.value,
              searchTerm: searchTerm.value,
              page: page
            }
          });
          console.log(response.data)
          users.value = response.data.Data.data; // Asumiendo que la respuesta contiene un array de usuarios
          currentPage.value = response.data.CurrentPage;
          itemsPerPage.value = response.data.PerPage;
          totalPages.value = response.data.TotalPages
        }
        loading.value = false
      } catch (error) {
        console.error('Error al obtener usuarios:', error);
        loading.value = false
      }
    };

    const deleteDoc = async () => {
      try {
        loadingDeleteDocuments.value = true;
        console.log(documentIdToDelete.value)
        await api.delete(`api/FiduDocumentos`,  {
          params: {
            docId: documentIdToDelete.value
          }
        });
        sortedDocuments.value = sortedDocuments.value.filter(doc => doc.id != documentIdToDelete.value)
        isDeleteConfirmVisible.value = false;
        documentIdToDelete.value = '';
        documentNameToDelete.value = '';
        documentUserNameToDelete.value = '';
        loadingDeleteDocuments.value = false;
      } catch (error) {
        console.error('Error al obtener formularios:', error);
      }
    };

    const toggleDetalle = (persona) => {
      if (expandedUserId.value === persona.id) {
        expandedUserId.value = '';
        documents.value = []; // Limpia la lista de documentos al contraer
      } else {
        expandedUserId.value = persona.id;
        fetchDocuments(persona); // Llama a fetchDocuments con el ID del usuario
      }
    };

    onBeforeUnmount(() => {
      if (connection) {
        connection.stop();
      }
    });

    onMounted(async() => {
      const lastUpdate = localStorage.getItem("lastUpdate");
      const today = new Date().toISOString().split("T")[0]; // Obtiene solo la fecha (YYYY-MM-DD)

      if (lastUpdate !== today) {
        localStorage.setItem("lastUpdate", today);
        window.location.reload(); // Recarga la página solo si no se ha recargado hoy
      }
      checkAuth();

      tipoDocsFromPermissions.value = getDocumentTypesFromPermissions();
      fetchUsers(1);
    });

    return {
      searchTerm,
      currentPage,
      totalPages,
      checkAuth,
      toggleDetalle,
      expandedUserId,
      fetchDocuments,
      loading,
      errors,
      documents,
      sortedDocuments,
      loadingDocuments,
      t,
      año,
      deleteDoc,
      isDeleteConfirmVisible,
      documentIdToDelete,
      documentNameToDelete,
      documentUserNameToDelete,
      loadingDeleteDocuments,
      hasEliminarDocFidu,
      showModal,
      fetchUsers,
      filterUsers,
      users,
      tipoDocsFromPermissions,
    };
  },
};
</script>

<style>
.permissions-list {
  margin-top: 10px;
}
.narrow-column {
  flex: 0 0 30px; /* Reduce el tamaño de la columna */
  max-width: 30px; /* Limita el ancho máximo */
}
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1001;
}
.modal-container {
  padding: 20px;
  border-radius: 8px;
  width: 400px;
}

.modal-content {
  width: 50%;
  background-color: var(--fondo-secundario);
  padding: 20px;
  border-radius: 10px;
  text-align: center;
  z-index: 1002;
}
</style>
